<template>
  <main class="col-md-9 ms-sm-auto col-lg-10 p-0">
    <div class="bg-card p-4 m-3" style="min-height: 70vh">
      <h5 class="text-blue-primary fw-bold pb-2">
        XARCADE GAMES END USER LICENSE AGREEMENT
      </h5>
      <hr class="border-theme" />
      <p class="pt-2 text-gray-text">
        This Xarcade End User License Agreement (‘Agreement”) is a legal
        document that explains your rights and obligations as a subscriber of
        Xarcade Solutions Sdn. Bhd. Xarcade Solutions Sdn. Bhd. (or Xarcade) is
        a company incorporated in Malaysia under the laws of Malaysia and having
        its registered office at (Company Address).
      </p>

      <h6 class="py-3 text-white opacity-75">
        1. REGISTRATION AS A SUBSCRIBER :
      </h6>
      <p class="text-gray-text">
        You become a subscriber of Xarcade (“Subscriber”) by completing of a
        Xarcade user account. This Agreement takes effect as soon as you
        indicate your acceptance of these terms. You may not become a Subscriber
        if you are under 13 years of age. Xarcade is not intended for children
        under 13 years of age and Xarcade Solutions Sdn. Bhd. will not knowingly
        collect personal information from children under 13 years of age.
      </p>

      <h6 class="py-3 text-white opacity-75">AGE REQUIREMENTS</h6>
      <p class="text-gray-text">
        You affirm that you are over the age of 13, as the game is not intended
        for children under 13. If you are 13 or older but under the age of 18,
        or the legal age of majority where you reside if that jurisdiction has
        an older age of majority, then you agree to review these terms with your
        parent or guardian to make sure that both you and your parent or
        guardian understand and agree to these terms. You agree to have your
        parent or guardian review and accept these terms on your behalf. If you
        are a parent or guardian agreeing to the terms for the benefit of a
        child over 13, then you agree to and accept full responsibility for that
        child's use of the game, including all financial charges, purchase and
        sale transactions, and legal liability that he or she may incur. We
        reserve the right in our sole discretion, including, without limitation,
        if required by a third party (e.g., payment service provider, third
        party platform, or operator of a secondary marketplace) or by law or
        regulation, to impose additional age requirements or restrictions on
        your engagement in certain events or transactions associated with the
        game. All engagements, activities, use of third party platforms or
        applications that are not part of or not integrated with xarcade
        platform are not governed by the terms of this eula. This includes dexs,
        centralized exchanges, wallet to wallet transfers etc...).
      </p>
      <div class="ps-4">
        <h6 class="py-3 text-white opacity-75">A. Contracting Party.</h6>
        <p class="text-gray-text">
          For any interaction with Xarcade your contractual relationship is with
          Xarcade Solutions Sdn. Bhd.. Except as otherwise indicated at the time
          of the transaction (such as in the case of purchases from another
          Subscriber in a Subscription Marketplace), any transactions for
          Subscriptions (as defined below) you make on Xarcade are being made
          from Xarcade Solutions Sdn. Bhd.
        </p>

        <h6 class="py-3 text-white opacity-75">
          B. Subscription – Content and Services.
        </h6>
        <p class="text-gray-text">
          As a Subscriber you may obtain access to certain services, software
          and content available to Subscribers. The Xarcade client software and
          any other software, content, and updates you download or access via
          Xarcade, including but not limited to Xarcade Solutions Sdn. Bhd. or
          third-party video games and in-game content, software associated with
          Hardware and any virtual items you trade, sell or purchase in a
          Xarcade Subscription Marketplace are referred to in this Agreement as
          "Content and Services;" the rights to access and/or use any Content
          and Services accessible through Xarcade are referred to in this
          Agreement as "Subscriptions."
        </p>
        <p class="text-gray-text">
          Each Subscription allows you to access particular Content and
          Services. Some Subscriptions may impose additional terms specific to
          that Subscription ("Subscription Terms") (for example, an end user
          license agreement specific to a particular game, or terms of use
          specific to a particular product or feature of Xarcade). Also,
          additional terms (for example, payment and billing procedures) may be
          posted on http://www.xarcade.io or within the Xarcade service ("Rules
          of Use"). Rules of Use include the Xarcade Online Conduct Rules
          http://xarcade.io/index.php?area=online_conduct and the Xarcade Refund
          Policy http://store.xarcade.io/Xarcade_refunds. The Subscription
          Terms, the Rules of Use, and the Xarcade Solutions Sdn. Bhd. Privacy
          Policy (which can be found at http://www.Xarcade Solutions Sdn.
          Bhd.software.com/privacy.htm) are binding on you once you indicate
          your acceptance of them or of this Agreement.
        </p>

        <h6 class="py-3 text-white opacity-75">C. Your Account.</h6>
        <p class="text-gray-text">
          When you complete Xarcade’s registration process, you create a Xarcade
          account ("Account"). Your Account may also include billing information
          you provide to Xarcade Solutions Sdn. Bhd. for the purchase of
          Subscriptions, Content and Services and any physical goods offered for
          purchase through Xarcade (“Hardware”). You may not reveal, share or
          otherwise allow others to use your password or Account except as
          otherwise specifically authorized by Xarcade Solutions Sdn. Bhd.. You
          are responsible for the confidentiality of your login and password and
          for the security of your computer system. Xarcade Solutions Sdn. Bhd.
          is not responsible for the use of your password and Account or for all
          of the communication and activity on Xarcade that results from use of
          your login name and password by you, or by any person to whom you may
          have intentionally or by negligence disclosed your login and/or
          password in violation of this confidentiality provision. Unless it
          results from Xarcade Solutions Sdn. Bhd.’s negligence or fault,
          Xarcade Solutions Sdn. Bhd. is not responsible for the use of your
          Account by a person who fraudulently used your login and password
          without your permission. If you believe that the confidentiality of
          your login and/or password may have been compromised, you must notify
          Xarcade Solutions Sdn. Bhd. via the support form
          (https://support.xarcade.io/newticket.php) without any delay.
        </p>
        <p class="text-gray-text">
          Your Account, including any information pertaining to it (e.g.:
          contact information, billing information, Account history and
          Subscriptions, etc.), is strictly personal. You may therefore not sell
          or charge others for the right to use your Account, or otherwise
          transfer your Account, nor may you sell, charge others for the right
          to use, or transfer any Subscriptions other than if and as expressly
          permitted by this Agreement (including any Subscription Terms or Rules
          of Use) or as otherwise specifically permitted by Xarcade Solutions
          Sdn. Bhd..
        </p>

        <h6 class="py-3 text-white opacity-75">D. Payment Processing.</h6>
        <p class="text-gray-text">
          Payment processing related to Content and Services and/or Hardware
          purchased on Xarcade is performed Xarcade Solutions Sdn. Bhd.
        </p>
      </div>
      <!-- step 1 ended here -->

        <h6 class="pt-5 text-white opacity-75">2. LICENSES</h6>

      <div id="step2" class="mt-4 ps-4">

        <h6 class="py-3 text-white opacity-75 mt-3"> A. General Content and Services License. </h6>
        <p class="text-gray-text">
         Xarcade and your
          Subscription(s) require the download and installation of Content and
          Services onto your computer. Xarcade Solutions Sdn. Bhd. hereby
          grants, and you accept, a non-exclusive license and right, to use the
          Content and Services for your personal, non-commercial use (except
          where commercial use is expressly allowed herein or in the applicable
          Subscription Terms). This license ends upon termination of (a) this
          Agreement or (b) a Subscription that includes the license. The Content
          and Services are licensed, not sold. Your license confers no title or
          ownership in the Content and Services. To make use of the Content and
          Services, you must have a Xarcade Account and you may be required to
          be running the Xarcade client and maintaining a connection to the
          Internet.
        </p>
        <p class="text-gray-text">
          For reasons that include, without limitation, system security,
          stability, and multiplayer interoperability, Xarcade may need to
          automatically update, pre-load, create new versions of or otherwise
          enhance the Content and Services and accordingly, the system
          requirements to use the Content and Services may change over time. You
          consent to such automatic updating. You understand that this Agreement
          (including applicable Subscription Terms) does not entitle you to
          future updates, new versions or other enhancements of the Content and
          Services associated with a particular Subscription, although Xarcade
          Solutions Sdn. Bhd. may choose to provide such updates, etc. in its
          sole discretion.
        </p>

        <h6 class="py-3 text-white opacity-75">B. Beta Software License.</h6>
        <p class="text-gray-text">
          Xarcade Solutions Sdn. Bhd. may from time to time make software
          accessible to you via Xarcade prior to the general commercial release
          of such software ("Beta Software"). You are not required to use Beta
          Software, but if Xarcade Solutions Sdn. Bhd. offers it, you may elect
          to use it under the following terms. Beta Software will be deemed to
          consist of Content and Services, and each item of Beta Software
          provided will be deemed a Subscription for such Beta Software, with
          the following provisions specific to Beta Software:
        </p>
        <p class="text-gray-text">
          Your right to use the Beta Software may be limited in time, and may be
          subject to additional Subscription Terms.
        </p>
        <p class="text-gray-text">
          Xarcade Solutions Sdn. Bhd. or any Xarcade Solutions Sdn. Bhd.
          affiliate may request or require that you provide suggestions,
          feedback, or data regarding your use of the Beta Software, which will
          be deemed User Generated Content under Section 6 (User Generated
          Content) below; and
        </p>
        <p class="text-gray-text">
          In addition to the waivers and limitations of liability for all
          Software under Section 7 (Disclaimers; Limitations on Liability; No
          Guarantees; Limited Warranty & Agreement) below as applicable, you
          specifically acknowledge that Beta Software is only released for
          testing and improvement purposes, in particular to provide Xarcade
          Solutions Sdn. Bhd. with feedback on the quality and usability of the
          Beta Software, and therefore contains errors, is not final and may create incompatibilities or damage to your computer, data, and/or software. If you decide to install and/or use Beta Software, you shall only use it in compliance with its purposes, i.e. for testing and improvement purposes and in any case not on a system or for purposes where the malfunction of the Beta Software can cause any kind of damage. In particular, maintain full backups of any system that you choose to install Beta Software on.
        </p>

         <h6 class="py-3 text-white opacity-75">C. License to Use Xarcade Solutions Sdn. Bhd. Microservice.</h6>
        <p class="text-gray-text">
          Your Subscription(s) may include access to various Xarcade Solutions Sdn. Bhd. tools that can be used to create content ("Microservice"). Some examples include: the Xarcade Solutions Sdn. Bhd. software development kit (the "SDK") for a version of the computer game engine known as "Source" (the "Source Engine") and the associated Xarcade Solutions Sdn. Bhd. Hammer editor, The Source® Filmmaker Software, or in-game tools through which you can edit or create derivative works of a Xarcade Solutions Sdn. Bhd. game. Particular Microservice (for example, The Source® Filmmaker Software) may be distributed with separate Subscription Terms that are different from the rules set forth in this Section. Except as set forth in any separate Subscription Terms applicable to the use of a particular Microservicel, you may use the Microservice, and you may use, reproduce, publish, perform, display and distribute any content you create using the Microservice, however you wish, but solely on a non-commercial basis.
        </p>
        <p class="text-gray-text">
         If you would like to use the Source Engine SDK or other Xarcade Solutions Sdn. Bhd. Microservice for commercial use, please contact Xarcade Solutions Sdn. Bhd. at <a href="mailto:info@xarcade.io">info@xarcade.io</a>
            </p>

      </div>
    </div>
  </main>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: 'viewLegalEula',
});
</script>
